import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type Me } from './useCommonQuery'
import { useCommonQueryKey } from './useCommonQueryKey'

export const useCommonQueryData = () => {
  const queryKey = useCommonQueryKey()
  const { data } = useQuery<Me | undefined>({ enabled: false, queryKey })

  return React.useMemo(() => data, [data])
}
